import { render, staticRenderFns } from "./DownloadAnnotations.vue?vue&type=template&id=59f867e9&scoped=true&"
import script from "./DownloadAnnotations.vue?vue&type=script&lang=js&"
export * from "./DownloadAnnotations.vue?vue&type=script&lang=js&"
import style0 from "./DownloadAnnotations.vue?vue&type=style&index=0&id=59f867e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f867e9",
  null
  
)

export default component.exports